import Default from './Default';

const AvaliacoesDesempenhoDefault = Default;

export default AvaliacoesDesempenhoDefault;
